(function () {
  const bindAutoplayPauseOnCards = (swiper, root, enabled) => {
    if (!enabled || !swiper.autoplay) {
      return;
    }

    const cards = root.querySelectorAll('.product-showcase__slide .product-card');

    cards.forEach((card) => {
      card.addEventListener('mouseenter', () => {
        swiper.autoplay.stop();
      });

      card.addEventListener('mouseleave', () => {
        swiper.autoplay.start();
      });

      card.addEventListener('focusin', () => {
        swiper.autoplay.stop();
      });

      card.addEventListener('focusout', (event) => {
        if (card.contains(event.relatedTarget)) {
          return;
        }
        swiper.autoplay.start();
      });
    });
  };

  const initProductShowcase = () => {
    if (typeof Swiper === 'undefined') {
      return;
    }

    document.querySelectorAll('[data-product-showcase]').forEach((root) => {
      if (root.dataset.productShowcaseInitialized === 'true') {
        return;
      }

      const mainElement = root.querySelector('[data-product-showcase-main]');
      const prevButton = root.querySelector('[data-product-showcase-prev]');
      const nextButton = root.querySelector('[data-product-showcase-next]');
      const paginationElement = root.querySelector('[data-product-showcase-pagination]');

      if (!mainElement) {
        return;
      }

      const slideCount = Number(root.dataset.productShowcaseCount) || 0;
      const autoplayEnabled = root.dataset.autoplay === 'true';
      const autoplayDelay = Number(root.dataset.autoplayDelay) || 5000;
      const pauseOnHover = root.dataset.autoplayPauseOnHover === 'true';

      const swiperOptions = {
        speed: 450,
        spaceBetween: 24,
        slidesPerView: 2,
        slidesPerGroup: 1,
        grabCursor: true,
        watchOverflow: true,
        breakpoints: {
          768: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 4,
            slidesPerGroup: 1,
            spaceBetween: 24,
          },
        },
      };

      if (prevButton && nextButton) {
        swiperOptions.navigation = {
          prevEl: prevButton,
          nextEl: nextButton,
        };
      }

      if (paginationElement) {
        swiperOptions.pagination = {
          el: paginationElement,
          clickable: true,
        };
      }

      if (autoplayEnabled && slideCount > 1) {
        swiperOptions.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: pauseOnHover,
        };
      }

      const mainSwiper = new Swiper(mainElement, swiperOptions);

      if (autoplayEnabled && pauseOnHover) {
        bindAutoplayPauseOnCards(mainSwiper, root, true);
      }

      root.dataset.productShowcaseInitialized = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductShowcase);
  } else {
    initProductShowcase();
  }

  document.addEventListener('shopify:section:load', initProductShowcase);
})();
